import { UrlBuilder } from '../helpers'
import { apiCall } from '../apiServerHelper'
import { apis } from '../apiUrls'

export const getSuburbs = async params => {
  return await apiCall(UrlBuilder(apis.SUBURB_DATABASE, params))
}
